import { BiBook, BiUser } from "react-icons/bi";
import {
  FaTachometerAlt,
  FaTasks,
  FaUsers,
  FaProjectDiagram,
} from "react-icons/fa";
import { GoReport } from "react-icons/go";
import { IoMdDoneAll } from "react-icons/io";
import { LiaFedora } from "react-icons/lia";
import { TbReportSearch } from "react-icons/tb";

const Data = [
  { id: 1, title: "Dashboard", icon: <FaTachometerAlt />, path: "/" },
  {
    id: 2,
    title: "Daily Work",
    icon: <FaTasks />,
    path: "/timeline",
  },
  { id: 3, title: "Projects", icon: <FaProjectDiagram />, path: "/projects" },
  { id: 4, title: "Learning", icon: <BiBook />, path: "/learning" },
  {
    id: 5,
    title: "Work Completed",
    icon: <IoMdDoneAll />,
    path: "/work-completed",
  },
  { id: 6, title: "Reports", icon: <TbReportSearch />, path: "/reports" },
  {
    id: 7,
    title: "Certificate",
    icon: <BiBook />,
    path: "/certificate",
  },
];

export default Data;
